// -----------------------------------------------
export function isEmpty(str) {
  return str === null || str === ''
}

// -----------------------------------------------
export function removeLineBreaks(str) {
  return str.replace(/[\r\n]+/gm, '')
}

// -----------------------------------------------
